module.exports = __webpack_public_path__ + "img/9788958285632.4913da6f.jpg";